import { Button } from 'ui';
import { useExportMedia } from 'features/media';

type P = {
  fileIds: string[];
};

const SaveZipButton = ({ fileIds }: P) => {
  const { isPending: isLoading, mutate: handleSaveZip } = useExportMedia();

  return (
    <Button
      loading={isLoading}
      onClick={(event) => {
        event.preventDefault();
        handleSaveZip({ fileName: 'Attachments.zip', ids: fileIds });
      }}
      type="link-primary"
    >
      Save all
    </Button>
  );
};

export default SaveZipButton;
